<div class="cub-wizard">
   <!-- Indicador de pasos -->
   <div class="cub-steps" *ngIf="mostrarIndicadorPasos">
      <ng-container *ngFor="let label of ['Verificar', 'Reemplazante', 'Cupos', 'Confirmar']; let i = index">
         <div class="cub-step" [class.is-active]="i === pasoActualIndex" [class.is-done]="i < pasoActualIndex">
            <div class="cub-step-circle">
               <i class="fas fa-check" *ngIf="i < pasoActualIndex"></i>
               <span *ngIf="i >= pasoActualIndex">{{ i + 1 }}</span>
            </div>
            <div class="cub-step-label">{{ label }}</div>
         </div>
         <div class="cub-step-connector" *ngIf="i < 3" [class.is-done]="i < pasoActualIndex"></div>
      </ng-container>
   </div>

   <div class="cub-alert cub-alert-danger" *ngIf="errorMessage">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
   </div>

   <div class="cub-loading" *ngIf="loading && step !== 'resumen'">
      <i class="fas fa-spinner fa-spin"></i> Procesando...
   </div>

   <!-- Cargando contexto inicial -->
   <ng-container *ngIf="step === 'cargando'">
      <div class="cub-empty-state">
         <i class="fas fa-spinner fa-spin fa-2x" style="color: #4782e1;"></i>
      </div>
   </ng-container>

   <!-- Paso: inicio -->
   <ng-container *ngIf="step === 'inicio' && contexto">
      <div class="cub-step-header">
         <div class="cub-step-icon"><i class="fas fa-people-arrows"></i></div>
         <div>
            <h5 class="cub-step-title">Transferir usuario base</h5>
            <p class="cub-step-subtitle">
               Transfiere tu rol de usuario base a otra persona para asegurar la continuidad de la administración y
               los pagos de la cuenta. La transferencia incluye <strong>todas tus empresas</strong>.
            </p>
         </div>
      </div>

      <div class="cub-alert cub-alert-info" *ngIf="contexto.empresas.length > 0">
         <i class="fas fa-building"></i>
         <span>
            Eres usuario base de <strong>{{ contexto.empresas.length }}</strong> empresa(s). Todas se transferirán al
            mismo reemplazante en un solo proceso.
         </span>
      </div>

      <div class="cub-empresas-table-wrap" *ngIf="contexto.empresas.length > 0">
         <table class="cub-empresas-table">
            <thead>
               <tr>
                  <th class="cub-col-index">#</th>
                  <th>Empresa</th>
                  <ng-container *ngIf="hayColumnaDerecha">
                     <th class="cub-col-index">#</th>
                     <th>Empresa</th>
                  </ng-container>
               </tr>
            </thead>
            <tbody>
               <tr *ngFor="let e of empresasColumnaIzquierda; let i = index">
                  <td class="cub-col-index">{{ indiceInicioPaginaEmpresas + i + 1 }}</td>
                  <td>
                     <div class="cub-empresas-table-nombre">
                        <i class="fas fa-building"></i>
                        <span [title]="e.razonSocial">{{ e.razonSocial }}</span>
                     </div>
                  </td>
                  <ng-container *ngIf="hayColumnaDerecha">
                     <ng-container *ngIf="empresasColumnaDerecha[i] as d; else celdaVacia">
                        <td class="cub-col-index">{{ indiceInicioPaginaEmpresas + i + 9 }}</td>
                        <td>
                           <div class="cub-empresas-table-nombre">
                              <i class="fas fa-building"></i>
                              <span [title]="d.razonSocial">{{ d.razonSocial }}</span>
                           </div>
                        </td>
                     </ng-container>
                     <ng-template #celdaVacia>
                        <td class="cub-col-index"></td>
                        <td></td>
                     </ng-template>
                  </ng-container>
               </tr>
            </tbody>
         </table>
      </div>

      <div class="cub-pagination" *ngIf="totalPaginasEmpresas > 1">
         <button type="button" class="btn-cub-link" [disabled]="paginaEmpresas === 1" (click)="irAPaginaEmpresas(-1)">
            <i class="fas fa-chevron-left"></i> Anterior
         </button>
         <span class="cub-pagination-info">Página {{ paginaEmpresas }} de {{ totalPaginasEmpresas }}</span>
         <button type="button" class="btn-cub-link" [disabled]="paginaEmpresas === totalPaginasEmpresas" (click)="irAPaginaEmpresas(1)">
            Siguiente <i class="fas fa-chevron-right"></i>
         </button>
      </div>

      <div class="cub-alert cub-alert-warning" *ngIf="contexto.empresas.length === 0">
         <i class="fas fa-circle-info"></i>
         <span>No se encontraron empresas activas donde seas usuario base.</span>
      </div>

      <div class="cub-actions">
         <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
         <button type="button" class="btn-cub-primary" [disabled]="loading || contexto.empresas.length === 0" (click)="iniciarCambio()">
            <i class="fas fa-arrow-right mr-1"></i> Iniciar transferencia
         </button>
      </div>
   </ng-container>

   <!-- Paso: hay una transferencia pendiente de activación de un usuario nuevo -->
   <ng-container *ngIf="step === 'pendiente-en-curso'">
      <div class="cub-empty-state">
         <div class="cub-empty-icon is-warning"><i class="fas fa-hourglass-half"></i></div>
         <div class="cub-empty-title">Transferencia en curso</div>
         <div class="cub-empty-text">
            Invitaste a <strong>{{ cambio?.emailReemplazante }}</strong> como nuevo usuario base de
            {{ cambio?.empresas?.length }} empresa(s). Quedará pendiente hasta que active su cuenta creando su
            contraseña. Mientras tanto conservas todos tus permisos.
         </div>
      </div>

      <div class="cub-field">
         <label>Motivo de cancelación (opcional)</label>
         <input type="text" [(ngModel)]="motivoCancelacion" placeholder="Ej: se ingresó un correo incorrecto" />
      </div>

      <div class="cub-actions">
         <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
         <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
            <i class="fas fa-times mr-1"></i> Cancelar transferencia
         </button>
      </div>
   </ng-container>

   <!-- Paso: verificación de correo -->
   <ng-container *ngIf="step === 'verificar'">
      <div class="cub-step-header">
         <div class="cub-step-icon"><i class="fas fa-envelope-open-text"></i></div>
         <div>
            <h5 class="cub-step-title">Verifica tu correo</h5>
            <p class="cub-step-subtitle">
               Enviamos un código de 6 dígitos a
               <strong>{{ correoBaseEnmascarado || 'tu correo' }}</strong>. Ingrésalo para continuar.
            </p>
         </div>
      </div>

      <div class="cub-alert cub-alert-success" *ngIf="codigoReenviado">
         <i class="fas fa-check-circle"></i>
         <span>Se reenvió un nuevo código a tu correo.</span>
      </div>

      <div class="cub-code-countdown" [class.is-expired]="segundosRestantesCodigo === 0" role="status" aria-live="polite">
         <i class="fas" [class.fa-clock]="segundosRestantesCodigo > 0" [class.fa-circle-exclamation]="segundosRestantesCodigo === 0"></i>
         <span *ngIf="segundosRestantesCodigo > 0">El código expira en <strong>{{ tiempoRestanteCodigo }}</strong></span>
         <span *ngIf="segundosRestantesCodigo === 0">El código expiró. Solicita uno nuevo para continuar.</span>
      </div>

      <div class="cub-otp-boxes">
         <input
            *ngFor="let d of codigoDigits; let i = index"
            [id]="'cub-verif-digit-' + i"
            class="cub-otp-box"
            [class.filled]="d"
            type="text"
            inputmode="numeric"
            maxlength="1"
            autocomplete="one-time-code"
            [value]="d"
            [disabled]="loading || segundosRestantesCodigo === 0"
            (input)="onDigitInput(i, $event)"
            (keydown)="onDigitKeydown(i, $event)"
            (paste)="onDigitPaste(i, $event)"
         />
      </div>

      <div class="cub-actions">
         <button type="button" class="btn-cub-link" [disabled]="loading" (click)="reenviarCodigo()">
            <i class="fas mr-1" [class.fa-rotate-right]="!loading" [class.fa-spinner]="loading && processingAction === 'reenviar'" [class.fa-spin]="loading && processingAction === 'reenviar'"></i>
            {{ loading && processingAction === 'reenviar' ? 'Reenviando código…' : 'Reenviar código' }}
         </button>
         <div>
            <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
               Cancelar transferencia
            </button>
            <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
            <button type="button" class="btn-cub-primary" [disabled]="loading || !codigoCompleto || segundosRestantesCodigo === 0" (click)="confirmarCodigo()">
               <i class="fas fa-spinner fa-spin mr-1" *ngIf="loading && processingAction === 'verificar'"></i>
               {{ loading && processingAction === 'verificar' ? 'Verificando…' : 'Verificar' }}
            </button>
         </div>
      </div>
   </ng-container>

   <!-- Paso: selección de reemplazante -->
   <ng-container *ngIf="step === 'reemplazante' && contexto && cambio">
      <div class="cub-step-header">
         <div class="cub-step-icon"><i class="fas fa-user-plus"></i></div>
         <div>
            <h5 class="cub-step-title">Selecciona al reemplazante</h5>
            <p class="cub-step-subtitle">
               Elige un usuario existente en alguna de tus {{ cambio.empresas.length }} empresa(s), o ingresa los
               datos de una persona nueva. El reemplazante quedará como usuario base de todas ellas.
            </p>
         </div>
      </div>

      <div class="cub-mode-cards">
         <button type="button" class="cub-mode-card" [class.is-active]="modoReemplazante === 'existente'" (click)="modoReemplazante = 'existente'">
            <i class="fas fa-user-check"></i>
            <span>Usuario existente</span>
         </button>
         <button type="button" class="cub-mode-card" [class.is-active]="modoReemplazante === 'nuevo'" (click)="modoReemplazante = 'nuevo'">
            <i class="fas fa-user-plus"></i>
            <span>Nuevo usuario</span>
         </button>
      </div>

      <ng-container *ngIf="modoReemplazante === 'existente'">
         <div class="cub-field" *ngIf="contexto.usuariosElegibles.length > 0; else sinElegibles">
            <label>Usuario</label>
            <select [(ngModel)]="usuarioReemplazanteId">
               <option value="" disabled selected>Selecciona un usuario</option>
               <option *ngFor="let u of contexto.usuariosElegibles" [value]="u.usuarioId">
                  {{ u.nombre }} {{ u.apellidos }} ({{ u.email }}) — {{ u.emisorIds.length }} empresa(s)
                  <ng-container *ngIf="!u.activo"> — inactivo, se reactivará</ng-container>
               </option>
            </select>
         </div>
         <ng-template #sinElegibles>
            <div class="cub-alert cub-alert-warning">
               <i class="fas fa-circle-info"></i>
               <span>No hay otros usuarios en tus empresas para seleccionar como reemplazante.</span>
            </div>
         </ng-template>
         <div class="cub-actions">
            <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
               Cancelar transferencia
            </button>
            <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
            <button type="button" class="btn-cub-primary" [disabled]="loading || !usuarioReemplazanteId" (click)="seleccionarExistente()">
               Continuar <i class="fas fa-arrow-right ml-1"></i>
            </button>
         </div>
      </ng-container>

      <ng-container *ngIf="modoReemplazante === 'nuevo'">
         <div class="cub-form-grid">
            <div class="cub-field">
               <label>RUT</label>
               <input
                  type="text"
                  inputmode="numeric"
                  maxlength="12"
                  [ngModel]="nuevoRutFormateado"
                  (input)="onRutInput($event)"
                  placeholder="12.345.678-9"
               />
            </div>
            <div class="cub-field">
               <label>Correo</label>
               <input type="email" [(ngModel)]="nuevoEmail" placeholder="correo@empresa.cl" />
            </div>
            <div class="cub-field">
               <label>Nombre</label>
               <input type="text" [(ngModel)]="nuevoNombre" />
            </div>
            <div class="cub-field">
               <label>Apellidos</label>
               <input type="text" [(ngModel)]="nuevoApellidos" />
            </div>
         </div>
         <div class="cub-actions">
            <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
               Cancelar transferencia
            </button>
            <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
            <button type="button" class="btn-cub-primary" [disabled]="loading" (click)="seleccionarNuevo()">
               Continuar <i class="fas fa-arrow-right ml-1"></i>
            </button>
         </div>
      </ng-container>
   </ng-container>

   <!-- Paso: liberar cupo empresa por empresa -->
   <ng-container *ngIf="step === 'cupos' && cambio">
      <div class="cub-step-header">
         <div class="cub-step-icon is-warning"><i class="fas fa-triangle-exclamation"></i></div>
         <div>
            <h5 class="cub-step-title">Falta liberar cupo</h5>
            <p class="cub-step-subtitle" *ngIf="!cambio.requiereDesactivarUsuarioBaseActual">
               El reemplazante necesita un cupo disponible en cada empresa. Elige a quién desactivar en las empresas
               que aún no tienen espacio para continuar. La desactivación se aplicará recién al confirmar la
               transferencia, no ahora.
            </p>
            <p class="cub-step-subtitle" *ngIf="cambio.requiereDesactivarUsuarioBaseActual">
               Una de tus empresas tiene plan Independiente, que admite un solo usuario. La única forma de liberar
               cupo es desactivar tu propia cuenta, lo que libera espacio en <strong>todas</strong> tus empresas a la
               vez. Esto se aplicará recién al confirmar la transferencia, no ahora.
            </p>
         </div>
      </div>

      <ng-container *ngIf="cambio.requiereDesactivarUsuarioBaseActual; else eleccionLibre">
         <div class="cub-alert cub-alert-warning">
            <i class="fas fa-triangle-exclamation"></i>
            <span>
               Al confirmar la transferencia, tu cuenta actual se desactivará automáticamente para liberar cupo en
               tus {{ cambio.empresas.length }} empresa(s).
            </span>
         </div>
         <div class="cub-actions">
            <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
               Cancelar transferencia
            </button>
            <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
            <button type="button" class="btn-cub-primary" [disabled]="loading" (click)="confirmarDesactivacionBase()">
               <i class="fas fa-arrow-right mr-1"></i> Continuar
            </button>
         </div>
      </ng-container>

      <ng-template #eleccionLibre>
         <div class="cub-cupo-empresa" *ngFor="let empresa of empresasSinCupo">
            <div class="cub-cupo-empresa-header">
               <i class="fas fa-building"></i>
               <span>{{ empresa.razonSocial }}</span>
            </div>
            <div class="cub-user-list" *ngIf="empresa.usuariosParaDesactivar.length > 0; else sinUsuariosEmpresa">
               <div class="cub-user-row" *ngFor="let u of empresa.usuariosParaDesactivar">
                  <div class="cub-user-avatar">{{ (u.nombre[0] || '') + (u.apellidos[0] || '') }}</div>
                  <div class="cub-user-info">
                     <div class="cub-user-name">
                        {{ u.nombre }} {{ u.apellidos }}
                        <span *ngIf="u.usuarioId === cambio.usuarioBaseActualId">(tú, usuario base actual)</span>
                     </div>
                     <div class="cub-user-email">{{ u.email }}</div>
                  </div>
                  <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="liberarCupo(empresa, u)">
                     Desactivar
                  </button>
               </div>
            </div>
            <ng-template #sinUsuariosEmpresa>
               <p class="cub-step-subtitle">No hay otros usuarios activos en esta empresa. Contacta a soporte.</p>
            </ng-template>
         </div>

         <div class="cub-actions">
            <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
               Cancelar transferencia
            </button>
            <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
         </div>
      </ng-template>
   </ng-container>

   <!-- Paso: resumen y T&C -->
   <ng-container *ngIf="step === 'resumen' && cambio">
      <div class="cub-step-header">
         <div class="cub-step-icon"><i class="fas fa-clipboard-check"></i></div>
         <div>
            <h5 class="cub-step-title">Confirma la transferencia</h5>
            <p class="cub-step-subtitle">Revisa el resumen antes de confirmar el cambio.</p>
         </div>
      </div>

      <div class="cub-summary-card">
         <div class="cub-summary-row">
            <span class="cub-summary-label">Reemplazante</span>
            <span class="cub-summary-value">
               <ng-container *ngIf="cambio.reemplazanteNombre">{{ cambio.reemplazanteNombre }} {{ cambio.reemplazanteApellidos }}<br /></ng-container>
               {{ cambio.emailReemplazante }}
            </span>
         </div>
         <div class="cub-summary-row">
            <span class="cub-summary-label">Empresas incluidas</span>
            <span class="cub-summary-value">{{ cambio.empresas.length }}</span>
         </div>
         <div class="cub-summary-row">
            <span class="cub-summary-label">Cuándo se aplica</span>
            <span class="cub-summary-value">{{ cambio.esUsuarioNuevo ? 'Al activar su cuenta' : 'De inmediato' }}</span>
         </div>
      </div>

      <div class="cub-empresas-table-wrap" *ngIf="cambio.empresas.length > 0">
         <table class="cub-empresas-table">
            <thead>
               <tr>
                  <th class="cub-col-index">#</th>
                  <th>Empresa</th>
                  <ng-container *ngIf="hayColumnaDerecha">
                     <th class="cub-col-index">#</th>
                     <th>Empresa</th>
                  </ng-container>
               </tr>
            </thead>
            <tbody>
               <tr *ngFor="let e of empresasColumnaIzquierda; let i = index">
                  <td class="cub-col-index">{{ indiceInicioPaginaEmpresas + i + 1 }}</td>
                  <td>
                     <div class="cub-empresas-table-nombre">
                        <i class="fas fa-building"></i>
                        <span [title]="e.razonSocial">{{ e.razonSocial }}</span>
                     </div>
                  </td>
                  <ng-container *ngIf="hayColumnaDerecha">
                     <ng-container *ngIf="empresasColumnaDerecha[i] as d; else celdaVacia">
                        <td class="cub-col-index">{{ indiceInicioPaginaEmpresas + i + 9 }}</td>
                        <td>
                           <div class="cub-empresas-table-nombre">
                              <i class="fas fa-building"></i>
                              <span [title]="d.razonSocial">{{ d.razonSocial }}</span>
                           </div>
                        </td>
                     </ng-container>
                     <ng-template #celdaVacia>
                        <td class="cub-col-index"></td>
                        <td></td>
                     </ng-template>
                  </ng-container>
               </tr>
            </tbody>
         </table>
      </div>

      <div class="cub-pagination" *ngIf="totalPaginasEmpresas > 1">
         <button type="button" class="btn-cub-link" [disabled]="paginaEmpresas === 1" (click)="irAPaginaEmpresas(-1)">
            <i class="fas fa-chevron-left"></i> Anterior
         </button>
         <span class="cub-pagination-info">Página {{ paginaEmpresas }} de {{ totalPaginasEmpresas }}</span>
         <button type="button" class="btn-cub-link" [disabled]="paginaEmpresas === totalPaginasEmpresas" (click)="irAPaginaEmpresas(1)">
            Siguiente <i class="fas fa-chevron-right"></i>
         </button>
      </div>

      <div class="cub-alert cub-alert-info" *ngIf="cambio.esUsuarioNuevo">
         <i class="fas fa-clock"></i>
         <span>
            El reemplazante recibirá un correo para crear su contraseña. La transferencia quedará
            <strong>pendiente</strong> hasta que active su cuenta; conservarás tus permisos actuales mientras tanto.
         </span>
      </div>
      <div class="cub-alert cub-alert-info" *ngIf="!cambio.esUsuarioNuevo">
         <i class="fas fa-bolt"></i>
         <span>La transferencia se aplicará <strong>de inmediato</strong> al confirmar. Conservarás el perfil Administrador.</span>
      </div>
      <div class="cub-alert cub-alert-warning" *ngIf="cambio.requiereDesactivarUsuarioBaseActual">
         <i class="fas fa-triangle-exclamation"></i>
         <span>
            Al confirmar, tu cuenta actual se desactivará automáticamente (una de tus empresas es de plan
            Independiente). Esto ocurrirá solo si la transferencia se completa con éxito.
         </span>
      </div>

      <div class="cub-alert cub-alert-warning" *ngIf="terminosError">
         <i class="fas fa-triangle-exclamation"></i>
         <span>{{ terminosError }} No es posible confirmar la transferencia hasta que estén disponibles.</span>
      </div>

      <div class="cub-terms-row" *ngIf="terminos">
         <input type="checkbox" id="cubAceptaTerminos" [(ngModel)]="aceptaTerminos" />
         <label for="cubAceptaTerminos">
            He leído y acepto los
            <button type="button" class="btn-cub-link cub-terms-link" (click)="descargarTerminos()">
               Términos y Condiciones del cambio de usuario base</button
            >.
         </label>
      </div>

      <div class="cub-actions">
         <button type="button" class="btn-cub-danger-outline" [disabled]="loading" (click)="cancelarTransferencia()">
            Cancelar transferencia
         </button>
         <button type="button" class="btn-cub-secondary" (click)="cerrar()">Cerrar</button>
         <button
            type="button"
            class="btn-cub-primary"
            [disabled]="loading || !aceptaTerminos || !terminos"
            (click)="confirmarTransferencia()"
         >
            <i class="fas fa-spinner fa-spin mr-1" *ngIf="loading"></i>
            <i class="fas fa-check mr-1" *ngIf="!loading"></i>
            {{ loading ? 'Procesando transferencia…' : 'Confirmar transferencia' }}
         </button>
      </div>
   </ng-container>

   <!-- Paso: completado -->
   <ng-container *ngIf="step === 'completado' && cambio">
      <div class="cub-empty-state">
         <div class="cub-empty-icon"><i class="fas fa-circle-check"></i></div>
         <div class="cub-empty-title" *ngIf="!cambio.esUsuarioNuevo">Transferencia completada</div>
         <div class="cub-empty-title" *ngIf="cambio.esUsuarioNuevo">Invitación enviada</div>
         <div class="cub-empty-text" *ngIf="!cambio.esUsuarioNuevo">
            El usuario base de {{ cambio.empresas.length }} empresa(s) se transfirió correctamente.
         </div>
         <div class="cub-empty-text" *ngIf="cambio.esUsuarioNuevo">
            Se envió la invitación a {{ cambio.emailReemplazante }}. La transferencia de {{ cambio.empresas.length }}
            empresa(s) quedará pendiente hasta que active su cuenta.
         </div>
      </div>
      <div class="cub-actions" style="justify-content: center;">
         <button type="button" class="btn-cub-primary" (click)="cerrar()">Cerrar</button>
      </div>
   </ng-container>
</div>
